var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                {
                  staticClass: "primary white--text",
                  attrs: { height: "200px" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-lg": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs5: "" } },
                            [
                              _c("wz-avatar", {
                                attrs: {
                                  src: _vm.userAvatar + "?" + Math.random(),
                                  username: _vm.fullName,
                                  size: "128px"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "" } }, [
                            _c("div", [
                              _c("div", { staticClass: "headline" }, [
                                _vm._v(_vm._s(_vm.fullName))
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.account.type))])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    { staticStyle: { padding: "0px", position: "relative" } },
                    [
                      _c(
                        "v-fab-transition",
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showFab,
                                  expression: "showFab"
                                }
                              ],
                              attrs: {
                                color: "secondary",
                                dark: "",
                                absolute: "",
                                bottom: "",
                                right: "",
                                fab: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.openDialog()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("edit")])],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel",
                {
                  attrs: { expand: "" },
                  model: {
                    value: _vm.panel,
                    callback: function($$v) {
                      _vm.panel = $$v
                    },
                    expression: "panel"
                  }
                },
                [
                  _c(
                    "v-expansion-panel-content",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "v-list",
                                [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("cap")(
                                                  _vm.$t("yourInfos")
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-list",
                                { attrs: { "two-line": "", dense: "" } },
                                [
                                  _vm.user.job
                                    ? _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "primary--text"
                                                },
                                                [_vm._v("assignment_ind")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(_vm._s(_vm.user.job))
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("cap")(_vm.$t("job"))
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "primary--text" },
                                            [_vm._v("mail")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(_vm._s(_vm.user.mail))
                                          ]),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("cap")(
                                                  _vm.$t("loginEmail")
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.user.mailContact
                                    ? _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "primary--text"
                                                },
                                                [_vm._v("mail")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  _vm._s(_vm.user.mailContact)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("contactEmail")
                                                    )
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.user.phone
                                    ? _c("v-divider", { attrs: { inset: "" } })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.user.phone
                                    ? _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "primary--text"
                                                },
                                                [_vm._v("phone")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(_vm._s(_vm.user.phone))
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      _vm.user.ios
                                                        ? "IOS"
                                                        : "non IOS"
                                                    ) +
                                                    ")"
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isLevelFaq() && _vm.hideShowNotifButton
                    ? _c(
                        "v-expansion-panel-content",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-list",
                                      [
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _c("v-list-tile-title", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("cap")(
                                                        _vm.$t("NotifTitle")
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("v-list-tile-sub-title", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("NotifContent")
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3045256798
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c("v-card-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("MyPhoneContent")) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            block:
                                              _vm.$vuetify.breakpoint.xsOnly,
                                            disabled: !_vm.souscriptionBtn
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.souscriptionPush()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.souscriptionBtnTxt) +
                                              "\n                  "
                                          ),
                                          _c(
                                            "v-icon",
                                            { attrs: { dark: "", right: "" } },
                                            [_vm._v("notifications")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-card-actions", [
                                    _vm.isSubscribed
                                      ? _c(
                                          "section",
                                          {
                                            staticClass:
                                              "subscription-details js-subscription-details"
                                          },
                                          [
                                            _c(
                                              "p",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      flat: "",
                                                      dark: "",
                                                      block:
                                                        _vm.$vuetify.breakpoint
                                                          .xsOnly
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.sendNotif()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.testNotifBtnTxt
                                                      ) +
                                                        "\n                        "
                                                    ),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "primary--text",
                                                        attrs: { right: "" }
                                                      },
                                                      [_vm._v("send")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isLevelFaq()
                    ? _c(
                        "v-expansion-panel-content",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-list",
                                      [
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _c("v-list-tile-title", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("editFicheLayout")
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            677916148
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm.account.role !== "admin"
                            ? _c("wz-choose-layout-fiche-visiteur")
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            width: "600px",
            scrollable: !_vm.$vuetify.breakpoint.smAndDown,
            fullscreen: _vm.$vuetify.breakpoint.smAndDown
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "primary white--text",
                  staticStyle: { height: "76px" }
                },
                [
                  _vm.$vuetify.breakpoint.smAndDown
                    ? _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.cancel()
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("close")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("editProfil")))
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.$vuetify.breakpoint.smAndDown
                    ? _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.save()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("submit")))]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { style: { heightOfCard: !_vm.$vuetify.breakpoint.smAndDown } },
                [
                  _c("wz-img-upload", {
                    attrs: { disabled: _vm.imgLoading },
                    on: { change: _vm.saveImg }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm._f("cap")(_vm.$t("firstName")),
                      type: "text",
                      "prepend-icon": "accessibility"
                    },
                    model: {
                      value: _vm.userDialog.fname,
                      callback: function($$v) {
                        _vm.$set(_vm.userDialog, "fname", $$v)
                      },
                      expression: "userDialog.fname"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm._f("cap")(_vm.$t("lastName")),
                      type: "text",
                      "prepend-icon": "accessibility"
                    },
                    model: {
                      value: _vm.userDialog.lname,
                      callback: function($$v) {
                        _vm.$set(_vm.userDialog, "lname", $$v)
                      },
                      expression: "userDialog.lname"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm._f("cap")(_vm.$t("job")),
                      type: "text",
                      "prepend-icon": "assignment_ind"
                    },
                    model: {
                      value: _vm.userDialog.job,
                      callback: function($$v) {
                        _vm.$set(_vm.userDialog, "job", $$v)
                      },
                      expression: "userDialog.job"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    attrs: {
                      label: _vm._f("cap")(_vm.$t("email")),
                      type: "email",
                      "prepend-icon": "mail",
                      "data-vv-name": "email",
                      error: _vm.wzErrors.has("email"),
                      "error-messages": _vm.wzErrors.collect("email")
                    },
                    model: {
                      value: _vm.userDialog.mailContact,
                      callback: function($$v) {
                        _vm.$set(_vm.userDialog, "mailContact", $$v)
                      },
                      expression: "userDialog.mailContact"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm._f("cap")(_vm.$t("mobilephone")),
                      type: "telephone",
                      "prepend-icon": "phone",
                      error: _vm.wzErrors.has("phone"),
                      "error-messages": _vm.wzErrors.collect("phone")
                    },
                    model: {
                      value: _vm.userDialog.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.userDialog, "phone", $$v)
                      },
                      expression: "userDialog.phone"
                    }
                  }),
                  _vm._v(" "),
                  _vm.user.serviceSid != ""
                    ? _c("v-subheader", [
                        _vm._v(_vm._s(_vm._f("cap")(_vm.$t("MyPhoneOK"))))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user.serviceSid != ""
                    ? _c("v-checkbox", {
                        attrs: {
                          label: _vm._f("cap")(_vm.$t("MyPhone")),
                          "prepend-icon": "phone_iphone"
                        },
                        model: {
                          value: _vm.userDialog.ios,
                          callback: function($$v) {
                            _vm.$set(_vm.userDialog, "ios", $$v)
                          },
                          expression: "userDialog.ios"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("wz-switch-lang", { on: { change: _vm.updateLang } })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$vuetify.breakpoint.smAndDown ? _c("v-divider") : _vm._e(),
              _vm._v(" "),
              !_vm.$vuetify.breakpoint.smAndDown
                ? _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.cancel()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.save()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("submit")))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf1681ae", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf1681ae","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = null
// module chunks = 